import axios from '../../../axios';

const url = '/invoicingservice/api/candidate';

export const getCandidatesByInvoiceId = (invoiceId: string) =>
  axios.get(`${url}?invoiceId=${invoiceId}`);
